<template>
  <div class="px-40 py-16 bg-black">
    <div class="flex items-start justify-between gap-x-14 align-center">
      <div class="w-1/4 text-left">
        <a href="#" class="flex items-center space-x-3 rtl:space-x-reverse">
          <img
            src="../../../assets/logo.png"
            class="h-14"
            alt="FreeTalk Logo"
          />

          <span
            class="self-center text-2xl font-semibold text-white whitespace-nowrap"
            >FreeTalk</span
          >
        </a>
        <p class="py-5 text-base text-left">
          Choisissez FreeTalk et nous vous garantirons une liberté d'expression
          sans précédent
        </p>
        <div class="flex gap-5">
          <div
            class="flex items-center justify-center w-16 h-16 rounded-full bg-primary align-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="15"
              viewBox="0 0 9 15"
              fill="none"
            >
              <path
                d="M5.56272 8.72042V15H2.5446V8.72042H0.0372314V6.17419H2.5446V5.24778C2.5446 1.80843 4.04786 0 7.2285 0C8.20358 0 8.44735 0.149778 8.98133 0.27182V2.79031C8.38351 2.69046 8.21519 2.63499 7.59415 2.63499C6.85703 2.63499 6.46236 2.83469 6.1025 3.22855C5.74265 3.62241 5.56272 4.30473 5.56272 5.28106V6.17973H8.98133L8.06428 8.72596H5.56272V8.72042Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            class="flex items-center justify-center w-16 h-16 rounded-full bg-primary align-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="15"
              viewBox="0 0 9 15"
              fill="none"
            >
              <path
                d="M5.56272 8.72042V15H2.5446V8.72042H0.0372314V6.17419H2.5446V5.24778C2.5446 1.80843 4.04786 0 7.2285 0C8.20358 0 8.44735 0.149778 8.98133 0.27182V2.79031C8.38351 2.69046 8.21519 2.63499 7.59415 2.63499C6.85703 2.63499 6.46236 2.83469 6.1025 3.22855C5.74265 3.62241 5.56272 4.30473 5.56272 5.28106V6.17973H8.98133L8.06428 8.72596H5.56272V8.72042Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            class="flex items-center justify-center w-16 h-16 rounded-full bg-primary align-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="15"
              viewBox="0 0 9 15"
              fill="none"
            >
              <path
                d="M5.56272 8.72042V15H2.5446V8.72042H0.0372314V6.17419H2.5446V5.24778C2.5446 1.80843 4.04786 0 7.2285 0C8.20358 0 8.44735 0.149778 8.98133 0.27182V2.79031C8.38351 2.69046 8.21519 2.63499 7.59415 2.63499C6.85703 2.63499 6.46236 2.83469 6.1025 3.22855C5.74265 3.62241 5.56272 4.30473 5.56272 5.28106V6.17973H8.98133L8.06428 8.72596H5.56272V8.72042Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            class="flex items-center justify-center w-16 h-16 rounded-full bg-primary align-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="15"
              viewBox="0 0 9 15"
              fill="none"
            >
              <path
                d="M5.56272 8.72042V15H2.5446V8.72042H0.0372314V6.17419H2.5446V5.24778C2.5446 1.80843 4.04786 0 7.2285 0C8.20358 0 8.44735 0.149778 8.98133 0.27182V2.79031C8.38351 2.69046 8.21519 2.63499 7.59415 2.63499C6.85703 2.63499 6.46236 2.83469 6.1025 3.22855C5.74265 3.62241 5.56272 4.30473 5.56272 5.28106V6.17973H8.98133L8.06428 8.72596H5.56272V8.72042Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="flex flex-col w-1/4 px-10 gap-y-4">
        <h2 class="text-2xl font-bold text-left">Services</h2>
        <p class="text-xl text-left">UI/UX Design</p>
        <p class="text-xl text-left">Dev Sites Web</p>
        <p class="text-xl text-left">Dev App Mobiles</p>
        <p class="text-xl text-left">Référencement SEO</p>
      </div>
      <div class="flex flex-col w-1/4 px-10 gap-y-4">
        <h2 class="text-2xl font-bold text-left">Resources</h2>
        <p class="text-xl text-left">Conformité</p>
        <p class="text-xl text-left">Etude de Cas</p>
        <p class="text-xl text-left">Webinaires</p>
        <p class="text-xl text-left">Developpeurs</p>
      </div>
      <div class="flex flex-col w-1/4 px-10 gap-y-4">
        <h2 class="text-2xl font-bold text-left">Contact Information</h2>
        <p class="text-xl text-left">smartcodeurspro@gmail.com</p>
        <p class="text-xl text-left">+228 91 54 32 27 <br />+228 99 89 71 64</p>
        <p class="text-xl text-left">Lomé, Agbalépédo TOGO</p>
      </div>
    </div>
    <div class="py-4">
      <p class="text-lg">Copyright ⓒ FreeTalk, 2024. Tous Droits Réservés.</p>
    </div>
  </div>
</template>
